





import { defineComponent } from "@vue/composition-api";
import simplebar from "simplebar-vue";
import { isMacOS, isMobile } from "@/lib/browserUtils";

export default defineComponent({
  name: "CustomScroll",
  components: { simplebar },
  setup() {
    return {
      useNativeScroll: isMobile() || isMacOS(),
    };
  },
});
